import { Typography } from '@design-system/components/typography/typography';
import { list, sectionWrapper, tag, wrapper } from './Recommendation.css';
import { StartExclusiveBundleModalProps } from '../StartExclusiveBundleModal';
import { Tag } from '@design-system/components/tag/tag';
import { Row } from '@design-system/components/grid/grid';
import { ExternalLink } from '@design-system/components/link/externalLink';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';

export const Recommendation = ({
  dispatch,
}: Pick<StartExclusiveBundleModalProps, 'dispatch'>) => (
  <div className={wrapper}>
    <Typography variant="headline" size="large" align="center">
      What we recommend
    </Typography>
    <Typography variant="body" size="medium" fontWeight="normal" align="center">
      The simplest way to think about this:{' '}
      <b>it’s a price increase for new subscribers</b>
    </Typography>
    <div
      className={clsx(
        sectionWrapper,
        sprinkles({ bg: 'P-20', borderColor: 'P-80' }),
      )}
    >
      <Tag label="RECOMMENDED" className={tag} readonly />
      <Typography variant="body" size="large">
        Treat it as a price increase
      </Typography>
      <Typography variant="body" size="medium" fontWeight="normal">
        Launch your Exclusive subscription at your new price. Your existing
        Platform subscribers stay grandfathered in at current rate.
      </Typography>
      <ol className={list}>
        <li>
          <Typography variant="body" size="medium" fontWeight="normal">
            Optionally, do a late push to let people in at the old price before
            you switch.
          </Typography>
        </li>
        <li>
          <Typography variant="body" size="medium" fontWeight="normal">
            Publish new content to both Platform and Exclusive so everyone gets
            the same experience.
          </Typography>
        </li>
        <li>
          <Typography variant="body" size="medium" fontWeight="normal">
            Anyone new subscribes at your exclusive price going forward.
          </Typography>
        </li>
      </ol>
    </div>

    <div className={clsx(sectionWrapper, sprinkles({ bg: 'N-10' }))}>
      <Typography variant="body" size="medium" color="N-80">
        DOWN THE ROAD
      </Typography>
      <Typography variant="body" size="large">
        Differentiate your content
      </Typography>
      <Typography variant="body" size="medium" fontWeight="normal">
        Once you’ve settled in, you can start adding exclusive content - like
        challenges, nutrition or bonus programming - to give Platform
        subscribers a reason to upgrade. No need to think about this on day one.
      </Typography>
    </div>
    <Row alignCenter justifyCenter>
      <Typography variant="body" size="medium" fontWeight="normal">
        Learn more about Exclusive subscription strategies
      </Typography>
      <ExternalLink
        label="here"
        textColor="P-80"
        textVariant="body"
        textSize="medium"
        onClick={() => dispatch('helpMaterialsEvent', 'pricingArticle')}
        href="https://help.playbookapp.io/en/articles/13621806-how-to-turn-on-an-exclusive-subscription"
      />
    </Row>
  </div>
);
